import { dispatchAction } from '@ardoq/rxbeach';
import { KeyboardEventHandler } from 'react';
import { moveHighlightRequested, enterPressed } from '@ardoq/dropdown-menu';
import { isMac } from '@ardoq/common-helpers';

export const getOnKeyDown: (
  actionNamespace: string
) => KeyboardEventHandler<HTMLInputElement> = actionNamespace => event => {
  switch (event.key) {
    case 'ArrowUp':
    case 'Up':
      event.preventDefault();
      dispatchAction(moveHighlightRequested(-1), actionNamespace);
      break;

    case 'ArrowDown':
    case 'Down':
      event.preventDefault();
      dispatchAction(moveHighlightRequested(1), actionNamespace);
      break;

    case 'Enter':
      event.preventDefault();
      dispatchAction(
        enterPressed({ withMetaKey: isMac() ? event.metaKey : event.ctrlKey }),
        actionNamespace
      );
      break;
  }
};
